export const orderByAsc = (a, b) => (a > b ? -1 : 1);
export const orderByDesc = (a, b) => (a < b ? -1 : 1);

export const orderByAscWithParse = (a, b) => orderByAsc(parseFloat(a), parseFloat(b));
export const orderByDescWithParse = (a, b) => orderByDesc(parseFloat(a), parseFloat(b));

export const convertHotelDataToSegment = (data, summary) => {
  if (!data || !summary) {
    return summary;
  }

  const res = Object.keys(data).map((key) => {
    const item = data[key];
    const label = item.hotelcount === 0 ? 'None' : '$' + Math.round(item.lowestprice);

    return {
      second: item.star + ' Star',
      value: item.star,
      label,
    };
  });

  return [
    {
      second: 'All Star',
      value: 'ALL',
      label: '$' + Math.round(summary.MinPrice),
    },
    ...res.sort((a, b) => (a.value > b.value ? 1 : -1)).slice(-3),
  ];
};

export const updateRailMatrix = (railList) => {
  if (railList) {
    const matrixList = [];
    for (let index = 0; index < 4; index++) {
      let code = '';
      switch (index) {
        case 0:
          code = 'ALL';
          break;
        case 1:
          code = 'MORNING';
          break;
        case 2:
          code = 'MIDDAY';
          break;
        case 3:
          code = 'EVENING';
          break;
        default:
      }
      const matrix = {
        second: code,
        value: code,
        label: 'None',
      };

      matrixList.push(matrix);
    }
    for (let i = 0; i < railList.length; i++) {
      switch (true) {
        case railList[i].filterDepart >= 0 && railList[i].filterDepart <= 105900:
          if (railList[i].price < matrixList[1].label || matrixList[1].label == 'None') {
            matrixList[1].label = '$' + railList[i].price;
          }
          break;
        case railList[i].filterDepart >= 110000 && railList[i].filterDepart <= 135900:
          if (railList[i].price < matrixList[2].label || matrixList[2].label == 'None') {
            matrixList[2].label = '$' + railList[i].price;
          }
          break;
        case railList[i].filterDepart >= 140000 && railList[i].filterDepart <= 235900:
          if (railList[i].price < matrixList[3].label || matrixList[3].label == 'None') {
            matrixList[3].label = '$' + railList[i].price;
          }
          break;
        default:
          if (railList[i].price < matrixList[0].label || matrixList[0].label == 'None') {
            matrixList[0].label = '$' + railList[i].price;
          }
          break;
      }
      if (railList[i].price < matrixList[0].label || matrixList[0].label == 'None') {
        matrixList[0].label = '$' + railList[i].price;
      }
    }
    return matrixList;
  }
};

export const fromObjectToParams = (obj) => {
  //this function converts a simple object to params in this format:
  //name=value&name2=value2....
  return Object.keys(obj)
    .map((key) => `${key}=${obj[key]}`)
    .join('&');
};
